import React, { Component } from 'react';
import { Radio, RadioList } from 'components/Toggle';
import { FlexRow, RowTitle, RowsContainer } from './Common';

class RadioItem extends Component {
  onClick = () => this.props.onChange(this.props.item.value);

  render() {
    const {
      checked,
      item: { title }
    } = this.props;
    return (
      <FlexRow onClick={this.onClick}>
        <RowTitle>{title}</RowTitle>
        <Radio checked={checked} />
      </FlexRow>
    );
  }
}

const renderItem = (props) => <RadioItem {...props} />;

export default (props) => {
  const { items, onChange, selectedValue } = props;

  return (
    <RadioList
      containerComponent={RowsContainer}
      items={items}
      onChange={onChange}
      renderItem={renderItem}
      selectedValue={selectedValue}
    />
  );
};
